import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import images from "../images";

const styles = () => ({
    logo: {
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        width: "100%",
        height: ({ height }) => height,
    },
});

type Props = {
    height: number,
    light: boolean,
    monochrome: Boolean,
    url: string,
};

/**
 * Logo Component
 * @param {Props} props
 */
const Logo = ({
    height = 64,
    light = false,
    monochrome = false,
    url,
}: Props) => {
    const classes = makeStyles(styles)({ height, light, monochrome });
    return (
        <div
            className={classes.logo}
            style={{
                backgroundImage: `url(${url})`,
            }}
        />
    );
};

export default Logo;
